import React from "react";
import Img from "react-image";
import _ from "lodash";
import { connect } from "react-redux";
import srcIconCheck from "../../../../../../styles/img/icon-check-white.svg";
import moment from "moment";
import {
  postRepasSimple,
  postRepasMulti,
  getAllAliments,
  deleteRepasEvent,
  updateRepasEvent,
} from "../les-tabs-ducks/Repas.ducks";
import Biberon from "./tab-repas/Biberon";
import Legumes from "./tab-repas/Legumes";
import Feculents from "./tab-repas/Feculents";
import Proteines from "./tab-repas/Proteines";
import Fruits from "./tab-repas/Fruits";
import Desserts from "./tab-repas/Desserts";
import srcIconcloseBlue from "../../../../../../styles/img/close-blue.svg";
import Classnames from "classnames";
import { toUpperCaseFirst } from "../../../../../../ReactConst";
import { TimePickerCustom } from "../../../../../../../src/components"

const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;
const IconcloseBlue = () => (
  <Img src={srcIconcloseBlue} className="img-fluid recap-react" />
);

moment.locale("fr");

function notEmpty(value) {
  return !_.isEmpty(value);
}
class Repas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabActive: "",
      repasType: "",
      etatRepas: "",
      biberonVolume: 0,
      opacity: { opacity: 0.25, pointerEvents: "none" },
      recapAliments: [],
      recapOpen: false,
      initialized: false,
      isOpen: true,
      timeRepas: moment(),
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleTab = this.handleTab.bind(this);
    this.handleChangeBiberon = this.handleChangeBiberon.bind(this);
    this.handleChangeAliments = this.handleChangeAliments.bind(this);
    this.openRecap = this.openRecap.bind(this);
    this.deleteItemRecap = this.deleteItemRecap.bind(this);
    this.switchTabs = this.switchTabs.bind(this);
    this.windowClick = this.windowClick.bind(this);
    this.handleEventDelete = this.handleEventDelete.bind(this);
  }
  windowClick(event) {
    if (
      this.state.recapOpen &&
      !event.target.classList.contains("recap-react")
    ) {
      this.setState({
        recapOpen: false,
      });
    }
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.windowClick, false);
  }
  componentDidUpdate(prevProps) {
    if (
      !this.state.initialized &&
      (this.props.isUpdate || this.props.onlyView) &&
      !_.isEmpty(this.props.repasData)
    ) {
      let repasData = this.props.repasData;
      let alimentsList = _.isEmpty(repasData.aliments)
        ? []
        : repasData.aliments.map((aliment) => aliment.libelle);
      let biberonQuant = repasData.biberon ? repasData.quantite : 0;
      this.setState({
        timeRepas: moment(repasData.dateTime),
        repasType: repasData.repasType,
        etatRepas: repasData.etatRepas,
        biberonVolume: biberonQuant,
        recapAliments: alimentsList,
        initialized: true,
        tabActive: "biberon-tab",
      });
    }
  }
  componentDidMount() {
    if (window) {
      window.addEventListener("click", this.windowClick, false);
    }
    this.props.getAllAliments(localStorage.getItem("token"));
  }

  switchTabs(tab) {
    switch (tab) {
      case "biberon-tab":
        return (
          <Biberon
            biberonVolume={this.state.biberonVolume}
            handleReadySubmit={this.handleReadySubmit}
            readySubmit={this.state.readySubmit}
            handleSubmit={this.handleSubmit}
            handleChangeBiberon={this.handleChangeBiberon}
            aliments={this.props.modals.repas.aliments.aliments}
            recapAliments={this.state.recapAliments}
          />
        );
      case "legumes-tab":
        return (
          <Legumes
            handleReadySubmit={this.handleReadySubmit}
            readySubmit={this.state.readySubmit}
            handleSubmit={this.handleSubmit}
            handleChangeLegumes={this.handleChangeAliments}
            aliments={this.props.modals.repas.aliments.aliments}
            recapAliments={this.state.recapAliments}
          />
        );
      case "feculents-tab":
        return (
          <Feculents
            handleReadySubmit={this.handleReadySubmit}
            readySubmit={this.state.readySubmit}
            handleSubmit={this.handleSubmit}
            handleChangeFeculents={this.handleChangeAliments}
            aliments={this.props.modals.repas.aliments.aliments}
            recapAliments={this.state.recapAliments}
          />
        );
      case "proteines-tab":
        return (
          <Proteines
            handleReadySubmit={this.handleReadySubmit}
            readySubmit={this.state.readySubmit}
            handleSubmit={this.handleSubmit}
            handleChangeProteines={this.handleChangeAliments}
            aliments={this.props.modals.repas.aliments.aliments}
            recapAliments={this.state.recapAliments}
          />
        );
      case "fruits-tab":
        return (
          <Fruits
            handleReadySubmit={this.handleReadySubmit}
            readySubmit={this.state.readySubmit}
            handleSubmit={this.handleSubmit}
            handleChangeFruits={this.handleChangeAliments}
            aliments={this.props.modals.repas.aliments.aliments}
            recapAliments={this.state.recapAliments}
          />
        );
      case "desserts-tab":
        return (
          <Desserts
            handleReadySubmit={this.handleReadySubmit}
            readySubmit={this.state.readySubmit}
            handleSubmit={this.handleSubmit}
            handleChangeDesserts={this.handleChangeAliments}
            aliments={this.props.modals.repas.aliments.aliments}
            recapAliments={this.state.recapAliments}
          />
        );
    }
  }

  deleteItemRecap(data) {
    let VolumeBiberon = data.includes(" ml") ? 0 : this.state.biberonVolume;
    this.setState((prevState) => ({
      opacity:
        prevState.recapAliments.length === 1
          ? { opacity: 0.25, pointerEvents: "none" }
          : prevState.opacity,
      recapAliments: prevState.recapAliments.filter((item) => item !== data),
      biberonVolume: VolumeBiberon,
    }));
  }

  handleTab(string) {
    this.setState({ tabActive: string, recapOpen: false });
  }

  openRecap() {
    if (this.state.recapOpen === true) {
      this.setState({ recapOpen: false });
    } else {
      this.setState({ recapOpen: true });
    }
  }

  toggle() {
    this.props.toggle();
    this.setState({ readySubmit: false, repasType: "" });
  }

  handleChangeBiberon(data) {
    let filterList = this.state.recapAliments.filter(
      (item) => !item.includes(" ml")
    );
    this.setState({
      opacity:
        notEmpty(this.state.repasType) && notEmpty(this.state.etatRepas)
          ? { opacity: 1 }
          : { opacity: 0.25, pointerEvents: "none" },
      biberonVolume: parseInt(data.value),
      recapAliments: filterList.concat(data.name),
      recapOpen: false,
    });
  }

  handleChangeAliments(data) {
    if (!this.props.onlyView) {
      let filterList = [];
      if (this.state.recapAliments.includes(data.name)) {
        filterList = this.state.recapAliments.filter(
          (item) => item !== data.name
        );
        this.setState({
          opacity:
            notEmpty(this.state.repasType) &&
            notEmpty(this.state.etatRepas) &&
            notEmpty(this.state.recapAliments)
              ? { opacity: 1 }
              : { opacity: 0.25, pointerEvents: "none" },
          recapAliments: filterList,
          recapOpen: false,
        });
      } else {
        filterList = this.state.recapAliments.filter(
          (item) => item !== data.name
        );
        this.setState({
          opacity:
            notEmpty(this.state.repasType) && notEmpty(this.state.etatRepas)
              ? { opacity: 1 }
              : { opacity: 0.25, pointerEvents: "none" },
          recapAliments: filterList.concat(data.name),
          recapOpen: false,
        });
      }
    }
  }

  handleChange = (event) => {
    if (!this.props.onlyView) {
      let name = event.target.name;
      this.setState({ [name]: event.target.id, recapOpen: false }, () => {
        if (
          notEmpty(this.state.repasType) &&
          notEmpty(this.state.etatRepas) &&
          notEmpty(this.state.recapAliments)
        ) {
          this.setState({ opacity: { opacity: 1 } });
        } else {
          this.setState({ opacity: { opacity: 0.25, pointerEvents: "none" } });
        }
      });
    }
  };

  handleChangeDate = (date) => {
    if (!this.props.onlyView) {
      this.setState({ timeRepas: date }, () => {
        if (
          notEmpty(this.state.timeRepas)
        ) {
          this.setState({ opacity: { opacity: 1 } });
        } else {
          this.setState({ opacity: { opacity: 0.25, pointerEvents: "none" } });
        }
      });
    }
  };
  

  handleSubmit(event) {
    event.preventDefault();
    let listAlimentIds = [];
    let objBiberon = {};
    if (
      notEmpty(this.state.recapAliments) &&
      notEmpty(this.props.modals.repas.aliments.aliments)
    ) {
      const arryOfArr = _.values(this.props.modals.repas.aliments.aliments);
      let flattened = [].concat.apply([], arryOfArr);
      flattened.forEach((aliment) => {
        if (this.state.biberonVolume > 0 && aliment.libelle === "Biberon") {
          listAlimentIds.push(aliment.id);
        } else if (this.state.recapAliments.includes(aliment.libelle)) {
          listAlimentIds.push(aliment.id);
        }
      });
      if (
        this.props.isUpdate &&
        notEmpty(this.state.repasType) &&
        notEmpty(this.state.etatRepas) &&
        notEmpty(this.state.recapAliments) &&
        notEmpty(this.props.kidItem)
      ) {
        let data = {
          alimentsIds: listAlimentIds,
          dateTime: moment(this.state.timeRepas).format(),
          etatRepas: this.state.etatRepas,
          repasType: this.state.repasType,
          quantite: this.state.biberonVolume,
        };
        this.props.updateRepasEvent(
          localStorage.getItem("token"),
          this.props.idEvent,
          data,
          this.props.kidItem.id
        );
      } else if (
        this.props.submitMulti &&
        notEmpty(this.props.dataMulti) &&
        notEmpty(this.state.repasType) &&
        notEmpty(this.state.etatRepas) &&
        notEmpty(this.state.recapAliments)
      ) {
        let listIds = this.props.dataMulti.listChild;
        let data = {
          idsEnfants: listIds,
          repas: {
            alimentsIds: listAlimentIds,
            dateTime: moment(this.state.timeRepas).format(),
            etatRepas: this.state.etatRepas,
            repasType: this.state.repasType,
            quantite: this.state.biberonVolume,
          },
        };
        this.props.postRepasMulti(localStorage.getItem("token"), data);
      } else if (
        notEmpty(this.state.repasType) &&
        notEmpty(this.state.etatRepas) &&
        notEmpty(this.state.recapAliments) &&
        notEmpty(this.props.kidItem)
      ) {
        let data = {
          alimentsIds: listAlimentIds,
          dateTime: moment(this.state.timeRepas).format(),
          etatRepas: this.state.etatRepas,
          repasType: this.state.repasType,
          quantite: this.state.biberonVolume,
        };
        this.props.postRepasSimple(
          localStorage.getItem("token"),
          this.props.kidItem.id,
          data
        );
      }
    }
    this.props.handleSubmit();
  }
  componentWillUnmount() {
    this.setState({
      tabActive: "",
      repasType: "",
      etatRepas: "",
      biberonVolume: 0,
      opacity: { opacity: 0.25, pointerEvents: "none" },
      recapAliments: [],
      recapOpen: false,
      initialized: false,
    });
  }
  handleEventDelete(e) {
    e.preventDefault();
    this.props.deleteRepasEvent(
      localStorage.getItem("token"),
      this.props.idEvent,
      this.props.kidItem.id
    );
  }
  render() {
    return (
      <div
        className="tab-pane fade show active"
        id="repas-pane"
        role="tabpanel"
        aria-labelledby="absence-tab"
      >
        <div className="content">

        <h2 className="mb-2">À quelle heure ?</h2>
            <TimePickerCustom 
              isOpen={this.state.isOpen} 
              time={this.state.timeRepas} 
              handleChangeDate={this.handleChangeDate} 
              onlyView={this.props.onlyView}/>
          
          <h2 style={{ marginTop: "15px" }}>De quel repas s'agit-il ?</h2>
          <div className="row mx-n2 justify-content-center etat-sante px-3">
            <div className="col-md-4 px-2">
              <input
                onChange={this.handleChange}
                disabled={this.props.onlyView}
                type="radio"
                className="d-none"
                id="MIDI"
                value={this.state.repasType}
                name="repasType"
              />
              <label
                htmlFor="MIDI"
                className={Classnames("btn-white btn-border", {
                  active: this.state.repasType === "MIDI",
                })}
              >
                Midi
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                onChange={this.handleChange}
                disabled={this.props.onlyView}
                type="radio"
                className="d-none"
                id="GOUTER"
                value={this.state.repasType}
                name="repasType"
              />
              <label
                htmlFor="GOUTER"
                className={Classnames("btn-white btn-border", {
                  active: this.state.repasType === "GOUTER",
                })}
              >
                Goûter
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                onChange={this.handleChange}
                disabled={this.props.onlyView}
                type="radio"
                className="d-none"
                id="AUTRE"
                value={this.state.repasType}
                name="repasType"
              />
              <label
                htmlFor="AUTRE"
                className={Classnames("btn-white btn-border", {
                  active: this.state.repasType === "AUTRE",
                })}
              >
                Autre
              </label>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center buttons-filters mt-3 nav nav-tabs"
            id="repas-tabs"
            role="tablist"
          >
            <button
              id="biberon-tab"
              className={Classnames("btn-filter", {
                active: this.state.tabActive === "biberon-tab",
              })}
              onClick={() => this.handleTab("biberon-tab")}
              data-toggle="tab"
              role="tab"
            >
              Biberon
            </button>
            <button
              id="legumes-tab"
              className={Classnames("btn-filter", {
                active: this.state.tabActive === "legumes-tab",
              })}
              onClick={() => this.handleTab("legumes-tab")}
              data-toggle="tab"
              role="tab"
            >
              Légumes
            </button>
            <button
              id="feculents-tab"
              className={Classnames("btn-filter", {
                active: this.state.tabActive === "feculents-tab",
              })}
              onClick={() => this.handleTab("feculents-tab")}
              data-toggle="tab"
              role="tab"
            >
              Féculents
            </button>
            <button
              id="proteines-tab"
              className={Classnames("btn-filter", {
                active: this.state.tabActive === "proteines-tab",
              })}
              onClick={() => this.handleTab("proteines-tab")}
              data-toggle="tab"
              role="tab"
            >
              Protéines
            </button>
            <button
              id="fruits-tab"
              className={Classnames("btn-filter", {
                active: this.state.tabActive === "fruits-tab",
              })}
              onClick={() => this.handleTab("fruits-tab")}
              data-toggle="tab"
              role="tab"
            >
              Fruits
            </button>
            <button
              id="desserts-tab"
              className={Classnames("btn-filter", {
                active: this.state.tabActive === "desserts-tab",
              })}
              onClick={() => this.handleTab("desserts-tab")}
              data-toggle="tab"
              role="tab"
            >
              Desserts
            </button>
          </div>
          <div className="tab-content">
            {this.switchTabs(this.state.tabActive)}
            <div className="d-flex justify-content-center mt-4">
              <div className="btn-group recap-repas dropup">
                <button
                  onClick={() => {
                    this.openRecap();
                  }}
                  type="button"
                  className="recap-react custom-input box-shadow btn-recap-repas dropdown-toggle"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Voir le récapitulatif repas{" "}
                </button>
                {this.state.recapOpen ? (
                  <div
                    className="dropdown-menu box-shadow recap-react"
                    style={{ display: "block" }}
                  >
                    <ul className="recap-react">
                      {this.state.recapAliments.map((item, index) => {
                        return item ? (
                          <li className="recap-react" key={index}>
                            <a
                              onClick={() => this.deleteItemRecap(item)}
                              className="delete-item recap-react"
                            >
                              <IconcloseBlue className="recap-react" />
                            </a>
                            {toUpperCaseFirst(item)}
                          </li>
                        ) : (
                          ""
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <h2 style={{ marginTop: "15px" }}>A-t il bien mangé ?</h2>
          <div className="row mx-n2 justify-content-center etat-sante px-3">
            <div className="col-md-4 px-2">
              <input
                onChange={this.handleChange}
                disabled={this.props.onlyView}
                type="radio"
                className="d-none"
                id="PEU"
                value={this.state.etatRepas}
                name="etatRepas"
              />
              <label
                htmlFor="PEU"
                className={Classnames("btn-white btn-border", {
                  active: this.state.etatRepas === "PEU",
                })}
              >
                Peu
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                onChange={this.handleChange}
                disabled={this.props.onlyView}
                type="radio"
                className="d-none"
                id="CORRECTEMENT"
                value={this.state.etatRepas}
                name="etatRepas"
              />
              <label
                htmlFor="CORRECTEMENT"
                className={Classnames("btn-white btn-border", {
                  active: this.state.etatRepas === "CORRECTEMENT",
                })}
              >
                Bien
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                onChange={this.handleChange}
                disabled={this.props.onlyView}
                type="radio"
                className="d-none"
                id="BEAUCOUP"
                value={this.state.etatRepas}
                name="etatRepas"
              />
              <label
                htmlFor="BEAUCOUP"
                className={Classnames("btn-white btn-border", {
                  active: this.state.etatRepas === "BEAUCOUP",
                })}
              >
                Beaucoup
              </label>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          {this.props.onlyView ? (
            ""
          ) : (
            <button
              type="submit"
              className="btn-gradient btn-valid"
              onClick={(event) =>
                this.handleSubmit(event, this.state.readySubmit)
              }
              style={this.state.opacity}
            >
              <IconCheckWhite /> Valider
            </button>
          )}
          {this.props.isUpdate ? (
            <button onClick={this.handleEventDelete} className="btn-supprimer">
              Supprimer
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = {
  postRepasSimple,
  postRepasMulti,
  getAllAliments,
  deleteRepasEvent,
  updateRepasEvent,
};
const mapStateToProps = ({ modals }) => ({ modals });
const withStore = connect(mapStateToProps, mapDispatchToProps);
export default withStore(Repas);
